import React from "react"
import {connect} from 'react-redux'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"

import extendedTablesStyle from "./extendedTablesStyle.jsx"

import {primaryColor} from "../../assets/jss/material-dashboard-pro-react";
import {mapService} from "../../_services";

import ReactTable from "../../components/react-table";
import Button from "../../components/CustomButtons";
import {sweetAlertActions} from "../../_actions";
import CustomInput from "../../components/CustomInput";
import {update_organisation_list} from "../helper_functions/locations";
import ClipboardButton from "../../components/ClipboardButoon";
import {getUserType} from "../../_services/authenticate";
import { Alert } from "@mui/material";

class Organisations extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      totalResults: 0,
      totalPages: 0,
      pageSize: 10,
      currentPage: 1,
      show_deactivated: false,
      loading: false,
      updated_properties: {},
      data: [],
    }

    this.timer = null
    this._is_mounted = false
  }

  componentDidMount() {
    this._is_mounted = true
    this.refresh()
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    this._is_mounted = false
  }

  refresh() {
    const {currentPage, pageSize, show_deactivated} = this.state
    this.setState({loading: true})

    mapService.getOrganisations(pageSize, currentPage - 1, show_deactivated, result => {
      const total_pages = Math.ceil(result.total / pageSize)
      let newCurrentPage = currentPage
      if (currentPage > total_pages && result.total > 0) {
        newCurrentPage = total_pages
      }

      this.setState({
        totalResults: result.total,
        currentPage: newCurrentPage,
        data: result.results,
        totalPages: total_pages,
        loading: false,
      })
    }, error => {
      this.setState({
        data: [],
        totalPages: 0,
        loading: false
      })
    });
  }

  change_value(value_name, value) {
    let {updated_properties} = this.state
    updated_properties[value_name] = value
    this.setState({updated_properties})
  }

  start_creating_organisation() {
    const {dispatch} = this.props
    const {updated_properties} = this.state
    dispatch(sweetAlertActions.clean({
      title: "Create New Organisation",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.create_new_organisation.bind(this),
      confirmBtnText: "Yes",
      content: <div>
        <CustomInput
          style={{
            fullWidth: true,
            width: "100%"
          }}
          id={"name"}
          labelText={"Name"}
          inputProps={{
            onChange: event => this.change_value("name", event.target.value),
            type: "text",
            value: updated_properties["name"]
          }}
        />
        <CustomInput
          style={{
            fullWidth: true,
            width: "100%"
          }}
          id={"client_name"}
          labelText={"Client Name"}
          inputProps={{
            onChange: event => this.change_value("client_name", event.target.value),
            type: "text",
            value: updated_properties["client_name"]
          }}
        />
      </div>
    }))

  }

  toggle_show_deactivated() {
    const {show_deactivated} = this.state
    this.setState({show_deactivated: !show_deactivated }, () => this.refresh());
  }

  start_updating_organisation(organisation_id, organisation) {
    const {dispatch} = this.props
    const {updated_properties} = this.state

    dispatch(sweetAlertActions.clean({
      title: "Update Organisation",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.update_organisation.bind(this, organisation_id, organisation),
      confirmBtnText: "Yes",
      content: <div>

        <p><b>Leave empty if you do not want to update the property</b></p>
        <p><b>Name:</b> {organisation["name"]}</p>
        <CustomInput
          style={{
            fullWidth: true,
            width: "100%"
          }}
          id={"name"}
          labelText={"New name"}
          inputProps={{
            onChange: event => this.change_value("name", event.target.value),
            type: "text",
            value: updated_properties["name"]
          }}
        />
        <p><b>Client Name:</b> {organisation["client_name"]}</p>
        <CustomInput
          style={{
            fullWidth: true,
            width: "100%"
          }}
          id={"client_name"}
          labelText={"New client name"}
          inputProps={{
            onChange: event => this.change_value("client_name", event.target.value),
            type: "text",
            value: updated_properties["client_name"]
          }}
        />
      </div>
    }))
  }

  update_organisation(organisation_id, organisation) {
    const {updated_properties} = this.state
    const {dispatch} = this.props;

    let new_name = undefined
    if (updated_properties["name"] !== undefined) {
      if (updated_properties["name"] !== organisation["name"]) {
        new_name = updated_properties["name"]
      }
    }

    let new_client_name = undefined
    if (updated_properties["client_name"] !== undefined) {
      if (updated_properties["client_name"] !== organisation["client_name"]) {
        new_client_name = updated_properties["client_name"]
      }
    }

    mapService.updateOrganisation(organisation_id, new_name, new_client_name, null, res => {
      dispatch(sweetAlertActions.clear())
      update_organisation_list()
      this.setState({
        updated_properties: {}
      }, () => this.refresh())
    }, error => {
      dispatch(sweetAlertActions.danger({ title: "Error updating the organisation." }))
    })
  }

  create_new_organisation() {
    const {updated_properties} = this.state
    const {dispatch} = this.props;
    mapService.createOrganisation(updated_properties["name"], updated_properties["client_name"], res => {
      dispatch(sweetAlertActions.clear())
      update_organisation_list()
      this.setState({
        updated_properties: {}
      }, () => this.refresh())
    })
  }


  deactivate_organisation(organisation) {
    const {dispatch} = this.props;
    mapService.updateOrganisation(organisation.id, null, null, true,res => {
      dispatch(sweetAlertActions.success({title: "Organisation is deactivated"}))
      update_organisation_list()
      this.refresh()
    }, error => {
      dispatch(sweetAlertActions.danger({ title: `Error deactivating ${organisation.name}.`, content: "Verify that all locations for this organisation have been deactivated." }))
    })
  }

  activate_organisation(organisation) {
    const {dispatch} = this.props;
    mapService.updateOrganisation(organisation.id, null, null, false,res => {
      dispatch(sweetAlertActions.success({title: "Organisation is activated"}))
      update_organisation_list()
      this.refresh()
    }, error => {
      dispatch(sweetAlertActions.danger({ title: `Error activating ${organisation.name}.` }))
    })
  }

  start_deactivating_organisation(organisation) {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.deactivate_organisation.bind(this, organisation),
      confirmBtnText: "Yes",
      content: <div>
        <h5>You will deactivate <b>{organisation.name}</b></h5>
        <Alert severity={"warning"}> Make sure ALL users are removed from this organisation first!</Alert>
        <p>Only a Nimbus System Admin can reverse this.</p>
      </div>
    }))
  }

  start_activating_organisation(organisation) {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.activate_organisation.bind(this, organisation),
      confirmBtnText: "Yes",
      content: <div>
        <h5>You will activate <b>{organisation.name}</b></h5>
      </div>
    }))
  }

  clear_popup() {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clear())
    this.setState({
      updated_properties: {}
    }, () => this.refresh())
  }

  render() {
    const {
      currentPage,
      data,
      pageSize,
      loading,
      totalResults,
      totalPages,
      show_deactivated
    } = this.state

    let filler_size = (currentPage - 1) * pageSize
    if (filler_size < 0) {
      filler_size = 0
    }
    let filler_array = Array(filler_size).keys()
    let columns = [
      {
        Header: "ID",
        accessor: "id",
        filterable: false,
        sortable: false,
        maxWidth: 50,
        Cell: row => {
          return <ClipboardButton text={row.value}/>
        }
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Client Name",
        accessor: "client_name",
      },
    ]

    columns.push(
      {
        Header: "Actions",
        accessor: "id",
        Cell: row => {
          return <>
            {row.original.deactivated ?
              <>
                {getUserType() === "system_admin" ?
                  <Button
                    color="warning"
                    simple
                    onClick={this.start_activating_organisation.bind(this, row.original)}
                  >
                    <b>{"Activate"}</b>
                  </Button> :
                  <p>Contact your Nimbus System Manager to activate again.</p>
                }
              </>:
              <>
                <Button
                  color="primary"
                  simple
                  onClick={this.start_updating_organisation.bind(this, row.value, row.original)}
                >
                  <b>{"Update"}</b>
                </Button>
                {getUserType() === "system_admin" &&
                  <Button
                    color="danger"
                    simple
                    onClick={this.start_deactivating_organisation.bind(this, row.original)}
                  >
                    <b>{"Deactivate"}</b>
                  </Button>
                }
              </>
            }
          </>
        }
      }
    )

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader>
              <GridContainer>
                <GridItem xs={10}>
                  <h4 style={{color: primaryColor}}><b>{"Overview Organisations"}</b></h4>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={6}>
                  <h5># Results: {totalResults}</h5>
                </GridItem>
                <GridItem xs={6} style={{textAlign: "right", justifyContent: "right"}}>
                  <Button color="primary" simple
                          onClick={this.toggle_show_deactivated.bind(this)}><b>{show_deactivated ? "Hide deactivated": "Show Deactivated"}</b></Button>
                   <Button color="primary" simple
                          onClick={this.start_creating_organisation.bind(this)}><b>{"Create Organisation"}</b></Button>
                </GridItem>
                <GridItem xs={12}>
                  <ReactTable
                    columns={columns}
                    data={[
                      ...filler_array,
                      ...data
                    ]}
                    sortable={false}
                    filterable={false}
                    loading={loading}
                    pages={totalPages}
                    page={currentPage - 1}
                    pageSize={pageSize}
                    onPageChange={(pageIndex) => this.setState({currentPage: pageIndex + 1}, () => this.refresh())}
                    onPageSizeChange={(newPageSize) => {
                      this.setState({
                        currentPage: 1,
                        pageSize: newPageSize
                      }, () => this.refresh())
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }
}


function mapStateToProps(state) {
  return {
  }
}


export default withStyles(extendedTablesStyle)(connect(mapStateToProps)(Organisations))
